import callAPI from "../callApi";
import path from "../variables";

const CashRegister = {
	xReport: (filter?: string) =>
		callAPI("GET", `${path.base}/cash-register/x-report${filter || ""}`, "", "generating X report"),
	zReport: (filter?: string) =>
		callAPI("POST", `${path.base}/cash-register/z-report${filter || ""}`, "", "generating Z report"),
	history: (filter?: string) =>
		callAPI("GET", `${path.base}/cash-register/history${filter || ""}`, "", "getting Z report history"),
};

export default CashRegister;
